import { Link } from "react-router-dom";
import "./Footer.css";

function Footer({ logo, brandName, quickLinks, contactInfo, contactPerson, copyright }) {

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">

      {/* LOGO */}
      <div className="footer-logo">
        <Link to="/" className="logo-link" onClick={scrollToTop}>
          {logo && <img src={logo} alt={brandName || ''} />}
          <span>{brandName || ''}</span>
        </Link>
      </div>

      {/* MAIN CONTENT */}
      <div className="footer-content">

        {/* QUICK LINKS */}
        <div className="footer-column">
          <h4>Quick Links</h4>

          {(quickLinks || []).map((link, index) => (
            <span key={index}>
              <Link to={link.path || '/'} onClick={scrollToTop}>{link.label || ''}</Link>
              <br />
            </span>
          ))}
        </div>

        {/* CONTACT INFO */}
        {contactInfo && (
          <div className="footer-column">
            <h4>Contact</h4>

            {contactInfo.address && <p>{contactInfo.address}</p>}

            {(contactInfo.emails || []).map((email, index) => (
              <a key={index} href={`mailto:${email}`}>
                📧 {email}
              </a>
            ))}

            {contactInfo.phone && (
              <a href={`tel:${contactInfo.phone}`}>
                📞 {contactInfo.phone}
              </a>
            )}

            {contactInfo.website && (
              <a
                href={`https://${contactInfo.website}`}
                target="_blank"
                rel="noreferrer"
              >
                🌐 {contactInfo.website}
              </a>
            )}
          </div>
        )}

        {/* CONTACT PERSON */}
        {contactPerson && (
          <div className="footer-column">
            <h4>Contact Person</h4>

            {contactPerson.name && <p><strong>{contactPerson.name}</strong></p>}
            {contactPerson.title && <p>{contactPerson.title}</p>}

            {contactPerson.phone && (
              <>
                <a href={`tel:${contactPerson.phone}`}>
                  📞 {contactPerson.phone}
                </a>
                <br />
              </>
            )}

            {contactPerson.email && (
              <>
                <a href={`mailto:${contactPerson.email}`}>
                  📧 {contactPerson.email}
                </a>
                <br />
              </>
            )}

            <Link to="/contact" className="footer-message-link">
              Send us a message →
            </Link>
          </div>
        )}

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        {copyright || ''}
      </div>

    </footer>
  );
}

export default Footer;
